import React, { useState, useEffect } from 'react';
import { fetchPipeline } from '../api/Pipeline';

function phaseLabel(phase) {
  const map = { PHASE2: 'Phase 2', PHASE3: 'Phase 3', PHASE4: 'Phase 4' };
  return map[phase] || phase;
}

function phaseColor(phase) {
  if (phase === 'PHASE3' || phase === 'PHASE4') return { color: '#8a5920', bg: '#f5eee3' };
  return { color: '#22381F', bg: '#e8eeea' };
}

export default function PipelineStrip({ onConditionClick }) {
  const [drugs, setDrugs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    fetchPipeline()
      .then(setDrugs)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="pipeline-strip">
      <div className="strip-header">
        <h2 className="strip-title">What's Being Tested Right Now</h2>
      </div>
      <div className="loading-container">
        <div className="spinner" />
        <p className="status">Loading active trials from ClinicalTrials.gov...</p>
      </div>
    </div>
  );

  if (drugs.length === 0) return null;

  const displayed = showAll ? drugs : drugs.slice(0, 9);

  return (
    <div className="pipeline-strip">
      <div className="strip-header">
        <h2 className="strip-title">What's Being Tested Right Now</h2>
        <p className="strip-subtitle">
          Drugs currently recruiting in active clinical trials. Click any to look it up.
        </p>
      </div>

      <div className="strip-grid">
        {displayed.map((drug, i) => (
          <DrugCard key={i} drug={drug} onClick={() => onConditionClick(drug.name)} />
        ))}
      </div>

      {drugs.length > 9 && (
        <div className="strip-footer">
          <button className="strip-toggle" onClick={() => setShowAll(!showAll)}>
            {showAll ? 'Show less ↑' : `See more ↓`}
          </button>
        </div>
      )}

      <p className="strip-note">
        Data from ClinicalTrials.gov · Only RECRUITING trials · Updated in real time
      </p>
    </div>
  );
}

function DrugCard({ drug, onClick }) {
  const { color, bg } = phaseColor(drug.phase);
  return (
    <button className="strip-drug-card" onClick={onClick}>
      <div className="strip-drug-header">
        <span className="strip-phase" style={{ color, backgroundColor: bg }}>
          {phaseLabel(drug.phase)}
        </span>
        {drug.industrySponsored && (
          <span className="strip-industry-badge">Industry</span>
        )}
      </div>
      <p className="strip-drug-name">{drug.name}</p>
      {drug.conditions.length > 0 && (
        <p className="strip-drug-conditions">
          {drug.conditions.join(' · ')}
        </p>
      )}
      <div className="strip-drug-meta">
        <span>{drug.trialCount} {drug.trialCount === 1 ? 'trial' : 'trials'}</span>
        <span>{drug.totalEnrollment.toLocaleString()} participants</span>
      </div>
    </button>
  );
}
